<template>
  <b-img
    height="30"
    :src="imgSrc"
    alt="logo"
  />
</template>

<script>

import { BImg } from 'bootstrap-vue'

export default {
  name: 'Logo',
  components: { BImg },
  props: {
    logoUrl: {
      type: String,
      default: null,
    },
  },
  computed: {
    imgSrc() {
      return this.logoUrl ? this.logoUrl : require(`@/assets/images/logo/${process.env.VUE_APP_LOGO_BRAND}`)
    },
  },
}
</script>
